import React, { SVGAttributes, FC } from "react";

export const ArrowDownIcon: FC<SVGAttributes<SVGElement>> = ({ color = '#202635', ...props }) => {
  return (
    <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M9.85355 0.853553C10.0488 0.658291 10.0488 0.341709 9.85355 0.146447C9.65829 -0.0488155 9.34171 -0.0488155 9.14645 0.146447L9.85355 0.853553ZM0.853553 0.146447C0.658291 -0.0488155 0.341709 -0.0488155 0.146447 0.146447C-0.0488155 0.341709 -0.0488155 0.658291 0.146447 0.853553L0.853553 0.146447ZM5 5L4.64645 5.35355L5 5.70711L5.35355 5.35355L5 5ZM9.14645 0.146447L4.64645 4.64645L5.35355 5.35355L9.85355 0.853553L9.14645 0.146447ZM5.35355 4.64645L0.853553 0.146447L0.146447 0.853553L4.64645 5.35355L5.35355 4.64645Z" fill={color} />
    </svg>
  );
};
